import { useEffect, useRef } from 'react';
import { useChat } from '../../hooks/useChat';
import { MessageBubble } from './MessageBubble';
import { TypingIndicator } from './TypingIndicator';
import { EscalationBanner } from './EscalationBanner';

export function MessageList() {
  const { messages, isSending, escalated, retryMessage } = useChat();
  const bottomRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  // Auto-scroll only when user is already near the bottom
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 120;
    if (nearBottom) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isSending]);

  return (
    <div
      ref={containerRef}
      className="flex flex-1 flex-col overflow-y-auto py-2"
      role="log"
      aria-live="polite"
      aria-label="Conversation with Aria"
    >
      {messages.map((msg) => (
        <MessageBubble key={msg.id} message={msg} onRetry={retryMessage} />
      ))}

      {isSending && <TypingIndicator />}

      {escalated && <EscalationBanner />}

      <div ref={bottomRef} />
    </div>
  );
}
